import { Route } from '@angular/router';

import { LpgReportComponent } from './reports/lpg-report.component';
import { LpgDistCostsReportComponent } from './reports/summary-report/lpg-dist-costs-report.component';
import { LpgDistYearlyReportComponent } from './reports/compare-report/lpg-dist-yearly-report.component';
import { DailyReportComponent } from './reports/daily-report/daily-report.component';
import { LpgDistEntryComponent } from './data-entries/lpg-dist-data/lpg-dist-entry/lpg-dist-entry.component';
import { LpgPaymentEntryComponent } from './data-entries/payments-data/lpg-payment-entry/lpg-payment-entry.component';
import { LpgDistDetailComponent } from './data-entries/lpg-dist-data/lpg-dist-detail/lpg-dist-detail.component';
import { LpgDistPaymentDetailComponent } from './data-entries/payments-data/lpg-dist-payment-detail/lpg-dist-payment-detail.component';
import { LpgQuotaEntryComponent } from './data-entries/lpg-dist-data/lpg-quota-entry/lpg-quota-entry.component';
import { KantarMapComponent } from 'src/app/lpg-dist/data-entries/kantar-map/kantar-map.component';
import { LpgDistFileUploaderComponent } from './data-entries/lpg-dist-file-uploader/lpg-dist-file-uploader.component';
import { TrucksReportsComponent } from './reports/trucks-reports/trucks-reports.component';

export const lpgDistRoutes: Route[] = [
  { path: 'lpg-dist/report', component: LpgReportComponent },
  { path: 'lpg-dist/report/daily-report', component: DailyReportComponent },
  { path: 'lpg-dist/report/truck', component: TrucksReportsComponent},
  { path: 'lpg-dist/report/costs', component: LpgDistCostsReportComponent },
  { path: 'lpg-dist/report/yearly', component: LpgDistYearlyReportComponent },
  { path: 'lpg-dist/detail', component: LpgDistDetailComponent },
  { path: 'lpg-dist/data-entry/:mode', component: LpgDistEntryComponent },
  { path: 'lpg-dist/data-entry/:mode/:company/:loadTimestamp/:searchKey', component: LpgDistEntryComponent },
  { path: 'lpg-dist/payments', component: LpgPaymentEntryComponent },
  { path: 'lpg-dist/payments/:company/:payTimestamp/:paymentBillNo', component: LpgPaymentEntryComponent },
  { path: 'lpg-dist/payment', component: LpgDistPaymentDetailComponent },
  { path: 'lpg-dist/quta-entry', component: LpgQuotaEntryComponent},
  { path: 'lpg-dist/organisations', component: KantarMapComponent},
  { path: 'lpg-dist/file', component: LpgDistFileUploaderComponent}
];
